var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu-icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.986,
    height: 40.986,
    viewBox: "0 0 40.986 40.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5302",
    "data-name": "Caminho 5302",
    d: "M35.7,3.2H32.02V1.281a1.281,1.281,0,0,0-2.562,0V3.2H11.527V1.281a1.281,1.281,0,0,0-2.562,0V3.2H5.283A5.289,5.289,0,0,0,0,8.485V35.7a5.289,5.289,0,0,0,5.283,5.283H35.7A5.289,5.289,0,0,0,40.986,35.7V8.485A5.289,5.289,0,0,0,35.7,3.2ZM5.283,5.764H8.966V7.044a1.281,1.281,0,0,0,2.562,0V5.764H29.459V7.044a1.281,1.281,0,0,0,2.562,0V5.764H35.7a2.725,2.725,0,0,1,2.722,2.722v3.042H2.562V8.485A2.725,2.725,0,0,1,5.283,5.764ZM35.7,38.424H5.283A2.725,2.725,0,0,1,2.562,35.7V14.089H38.424V35.7A2.725,2.725,0,0,1,35.7,38.424Z",
    fill: "#000fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSelected);
export default __webpack_public_path__ + "static/media/calendar_selected.18c4bda442be70d04d7dd0bb1fdbf730.svg";
export { ForwardRef as ReactComponent };